export const appConfig = {
    favicon: "/icons/dipi_ico.webp",
    logo: "/images/dipi_ico.png",
    emptyImage: '/images/empty_content.svg',
    appName: "DIP Insights",
    logoutURL: '/logout',
    header: {
        showCircle: false,
        showNotifications: false,
        showLang: false,
        showChat: false
    },
    menu: {
        size: 'mini',
        showAppIcon: false,
        spacing: 0,
        width: {
            desktop: 55
        }
    }
}

export const styles = {
    main: {
        pr: 4
    }
}